<!-- Start FunFacts Area -->
<section class="funfacts-area ptb-110">
    <div class="container">
        <div class="row">

            <div class="col-lg-4 col-md-6 col-12 col-sm-12">
                <div class="single-funfacts">
                    <div class="circlechart" data-percentage="80"></div>
                    <span>Solar</span>
                    <h3>Solutions</h3>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12 col-sm-12">
                <div class="single-funfacts">
                    <div class="circlechart" data-percentage="90"></div>
                    <span>Happy</span>
                    <h3>Customers</h3>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12 col-sm-12">
                <div class="single-funfacts">
                    <div class="circlechart" data-percentage="85"></div>
                    <span>Solar</span>
                    <h3>Installations</h3>
                </div>
            </div>
        </div>
    </div>

    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
    </div>
</section>
<!-- End FunFacts Area -->